'use client';

import dynamic from 'next/dynamic';

function DemoSkeleton({ height = 'h-64' }: { height?: string }) {
  return (
    <div
      className={`${height} animate-pulse rounded-xl border border-white/[0.08] bg-white/[0.02]`}
    />
  );
}

export const ScoringDemoLazy = dynamic(
  () => import('./ScoringDemo').then((m) => ({ default: m.ScoringDemo })),
  { ssr: false, loading: () => <DemoSkeleton height="h-72" /> }
);

export const RoutingDemoLazy = dynamic(
  () => import('./RoutingDemo').then((m) => ({ default: m.RoutingDemo })),
  { ssr: false, loading: () => <DemoSkeleton height="h-48" /> }
);

export const BeforeAfterDemoLazy = dynamic(
  () => import('./BeforeAfterDemo').then((m) => ({ default: m.BeforeAfterDemo })),
  { ssr: false, loading: () => <DemoSkeleton height="h-96" /> }
);
